import React from "react";
import { Icon } from "@iconify/react";

const IconClose: React.FC = () => (
  <Icon icon="ic:round-close" color="red" fontSize={30} />
);
export default IconClose;
